import './App.css'

import { Routes, Route, BrowserRouter } from "react-router-dom"
import Dashboard from './pages/dashboard'
import AllCategory from 'pages/allCatelouge'
// import SubCategory from 'pages/subCategory'
import AddCartDetails from 'pages/addCartDetails'
import ProductDetails from 'pages/productDetails'
import OrderDetails from 'pages/orderDetails'
import HotOffer from 'pages/hotOffer'
import ConfirmOrder from 'pages/confirmOrder'
import CategoryWiseData from 'pages/categoryWiseData'
import SubCategoryWiseData from 'pages/subCategoryWiseData'
import NewProductsFullPage from 'pages/newProductsFullPage'
import TrendingProductsFullPage from 'pages/TrendingProductsFullPage'
import FreeDeliveryFullPage from 'pages/FreeDeliveryFullPage'
import ScrollToTop from 'components/ScrollTopOnReload'

function App() {

  return (
    <>
      <BrowserRouter>
      <ScrollToTop />
        <Routes>
          <Route path="/" exact element={<Dashboard />}></Route>
          <Route path="/home" exact element={<Dashboard />}></Route>
          <Route path="/category/:catalogueId" exact element={<CategoryWiseData />} />
          <Route path="/subCategory/:subCatalogueId" exact element={<SubCategoryWiseData />} />
          {/* <Route path="/category/:catalogueName" exact element={<AllCategory />} /> */}
          <Route path="/cart" exact element={<AddCartDetails />}></Route>
          <Route path="/details/:category/:id" exact element={<ProductDetails />}></Route>
          <Route path="/orderDetails" exact element={<OrderDetails />}></Route>
          <Route path="/allNewProduct" exact element={<NewProductsFullPage />}></Route>
          <Route path="/trendingProducts" exact element={<TrendingProductsFullPage />}></Route>
          <Route path="/freeDeliveryProducts" exact element={<FreeDeliveryFullPage />}></Route>
          <Route path="/hotOffer" exact element={<HotOffer />}></Route>
          <Route path="/confirmOrder" exact element={<ConfirmOrder />}></Route>
        </Routes>
      </BrowserRouter>
    </>
  )
}

export default App
